import LegalPage, { H2 } from "../components/LegalPage";
import { Link } from "react-router-dom";
import { openCookieSettings } from "../components/CookieConsent";

export default function Cookies() {
  return (
    <LegalPage title="Cookie Policy" updated="June 2026">
      <p>
        This Cookie Policy explains how SugaSpice Bakery &amp; Kitchen uses cookies and similar
        technologies (such as browser local storage) on <Link to="/" className="text-[#C8102E] underline">sugaspice.uk</Link>.
        It should be read alongside our <Link to="/privacy" className="text-[#C8102E] underline">Privacy Policy</Link>.
      </p>
      <p>
        Cookies are small files stored on your device. We use a small number of them. Non-essential
        cookies (analytics and marketing) are <strong>only</strong> set if you accept them — nothing
        non-essential loads before you give consent.
      </p>

      <H2>Managing your choices</H2>
      <p>
        When you first visit the site you can Accept all, Reject non-essential, or Manage preferences.
        You can change your mind at any time using{" "}
        <button onClick={openCookieSettings} data-testid="cookies-open-settings" className="text-[#C8102E] underline">Cookie Settings</button>{" "}
        (also linked in the footer). You can also block or delete cookies in your browser settings; the
        site will still work, but some features may be less convenient.
      </p>

      <H2>Cookies we use</H2>

      <CookieTable
        heading="Strictly necessary (always on)"
        rows={[
          ["ss_cookie_consent", "SugaSpice", "Remembers your cookie choices", "12 months", "Local storage"],
        ]}
      />

      <CookieTable
        heading="Analytics (only with consent)"
        rows={[
          ["ph_* / PostHog", "PostHog", "Measures how visitors use the site (pages viewed, basic device info) so we can improve it. Session recording is disabled.", "Up to 12 months", "Cookie / local storage"],
        ]}
      />

      <CookieTable
        heading="Marketing / advertising (only with consent)"
        rows={[
          ["_fbp", "Meta (Facebook)", "Used by the Meta Pixel to measure and improve our advertising", "Up to 3 months", "Cookie"],
        ]}
      />

      <H2>Functional cookies</H2>
      <p>We don't currently use optional "functional" cookies beyond the strictly necessary one above that stores your consent choice.</p>

      <H2>Third-party services</H2>
      <p>Some third parties may set their own cookies when their features are used or loaded:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li><strong>PostHog</strong> — analytics (loaded only with analytics consent).</li>
        <li><strong>Meta/Facebook Pixel</strong> — advertising measurement (loaded only with marketing consent).</li>
        <li><strong>Google Fonts &amp; Fontshare</strong> — deliver the site's fonts; these don't set advertising cookies but do process your IP address to serve the fonts.</li>
        <li><strong>Flipdish</strong> — if you click through to order online, you leave our site and Flipdish's own cookies and policies apply.</li>
      </ul>
      <p className="text-sm text-[#5C5C5C]">
        Cookie names and durations set by third parties can change; the categories above reflect how we use them.
      </p>
    </LegalPage>
  );
}

function CookieTable({ heading, rows }) {
  return (
    <div className="mt-6">
      <h3 className="font-semibold text-base mb-2">{heading}</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-[#D1C9BE]/70 rounded-lg">
          <thead className="bg-[#1A1A1A] text-[#F7F5F0]">
            <tr>
              <th className="text-left p-3">Name</th>
              <th className="text-left p-3">Provider</th>
              <th className="text-left p-3">Purpose</th>
              <th className="text-left p-3">Duration</th>
              <th className="text-left p-3">Type</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#D1C9BE]/60">
            {rows.map((r, i) => (
              <tr key={i}>
                {r.map((c, j) => <td key={j} className="p-3 align-top">{c}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
